import React, {Fragment, useState} from 'react';
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  setActiveStep,
  setActiveSlabUrl,
  setSlabImageWidth,
  setSlabImageHeight,
  setSlabSearchText,
  setSlabAspectRatio,
  setPricePerArea
} from "../../../../actions/sqftSlabFunctions";
import { getAspectRatio } from "../../helpers/sqftHelper";
import { SLAB_IMAGE_TYPES } from "../../../../reducers/sqftSlabReducer";
import ValidationPopupWindow from "../popup/ValidationPopupWindow";
import sqftConfig from "../canvas/store/sqftConfig";
import SqftLoadSlabPricingCheckbox from "./SqftLoadSlabPricingCheckbox";

const SqftLoadSlabHeader = (props) => {
  const {
    activeStep, slabImageHeight, slabImageWidth, cropperData, setSlabImageHeight,
    isSizeValidationFailed, setSlabImageWidth, setSlabSearchText, setSlabAspectRatio,
    pricePerArea, setPricePerArea, slabImageType
  } = props;
  const { cropperRef } = props;

  const { intl } = props;
  const SIZE = { width: 'width', height: 'height' };
  const IS_MASTER_PRICE_PERSQFT = false;
  const [isHeightFocused, setIsHeightFocused] = useState(false);
  const [isWidthFocused, setIsWidthFocused] = useState(false);
  let imageHeight = slabImageHeight;
  let imageWidth = slabImageWidth;

  const handleSizeChange = (value, type) => {
    // Remove non-numeric characters
    const rawValue = value.replace(/[^0-9]/g, '');
    const numericValue = parseInt(rawValue, 10) || 0;

    switch(type) {
      case SIZE.width:
        setSlabImageWidth(numericValue);
        imageWidth = numericValue;
        break;
      case SIZE.height:
        setSlabImageHeight(numericValue);
        imageHeight = numericValue;
        break;
    }
    let aspectHeight, aspectWidth;
    ({ aspectHeight, aspectWidth } = getAspectRatio(imageHeight, imageWidth));
    setSlabAspectRatio(aspectWidth / aspectHeight);
    if (cropperRef.current && cropperRef.current.cropper) {
      cropperRef.current.cropper.setAspectRatio(aspectWidth / aspectHeight);
    }
  };

  const onInputSearchChange = (searchText) => {
    setSlabSearchText(searchText);
  };

  const sizeInputError = (isSizeValidationFailed ? " size-input--error " : "");

  return (
    <div className="message-window-header-line slab-header">
      {
        activeStep === 0 ?
          <div className="slab-header__title">
            <FormattedMessage id={"sqft.popup.slab.selectImageType"} />
          </div>
          : ""
      }
      {
        activeStep === 0 && slabImageType === SLAB_IMAGE_TYPES.upload ?
            <SqftLoadSlabPricingCheckbox />
          : ""
      }
      {
        activeStep === 1 ?
          <div className="slab-header__search">
            <input type="text"
                   className="ui-input slab-header__search-input"
                   placeholder={intl.formatMessage({ id: "sqft.popup.slabmode.search" })}
                   onChange={(e) => onInputSearchChange(e.target.value)} />
          </div>
          : ""
      }
      {
        activeStep === 1 || (activeStep === 0 && slabImageType === SLAB_IMAGE_TYPES.placeholder)
          ?
          <Fragment>
            <div className="slab-header__size">
            <span className="slab-header__size-name">
              <FormattedMessage id={"sqft.popup.slabmode.size"} />
            </span>
              <span>
              <input type="text"
                     className={"ui-input slab-header__size-input size-input--height" + sizeInputError}
                     onFocus={() => setIsHeightFocused(true)}
                     onBlur={() => setIsHeightFocused(false)}
                     onChange={(e) => handleSizeChange(e.target.value, SIZE.height)}
                     value={isHeightFocused ? slabImageHeight : slabImageHeight + sqftConfig.getMeasureUnitPostfix(true)}
                     placeholder="0" />
            </span>
              <span className="slab-header__size-x">
              x
            </span>
              <span>
              <input type="text"
                     className={"ui-input slab-header__size-input size-input--width" + sizeInputError}
                     onFocus={() => setIsWidthFocused(true)}
                     onBlur={() => setIsWidthFocused(false)}
                     onChange={(e) => handleSizeChange(e.target.value, SIZE.width)}
                     value={isWidthFocused ? slabImageWidth : slabImageWidth + sqftConfig.getMeasureUnitPostfix(true)}
                     placeholder="0" />
            </span>
              <ValidationPopupWindow id={"slab-header-size"}
                                     text={"Enter the length and width of the slab."}
                                     position={{ top: 41, left: 177 }}
                                     isHidden={!isSizeValidationFailed}
              />
            </div>
            <SqftLoadSlabPricingCheckbox />
          </Fragment>
          : ""
      }
      {
        IS_MASTER_PRICE_PERSQFT
          ? <div className="slab-header__price">
            <span className="slab-header__size-name">
              <FormattedMessage id={"sqft.popup.slabmode.price"} />
            </span>
            <span>
              <input type="number"
                     className="ui-input slab-header__size-input size-input--height"
                     onChange={(e) => setPricePerArea(e.target.value)}
                     value={pricePerArea}
                     placeholder="0" />
            </span>
          </div>
          : null
      }
      {activeStep === 2
        ?
        <div className="slab-header__cropper">
          <div className="slab-header__cropper-size">
            <FormattedMessage id={"sqft.popup.slabmode.trimSize"} />
            <span>: </span>
            <span>{Math.ceil10(cropperData.width, -2)}x{Math.ceil10(cropperData.height, -2)}</span>
          </div>
          <div className="slab-header__cropper-position">
            <FormattedMessage id={"sqft.popup.slabmode.trimPosition"} />
            <span>: </span>
            <span>{Math.ceil10(cropperData.x, -2)}x{Math.ceil10(cropperData.y, -2)}</span>
          </div>
        </div>
        : null
      }
    </div>
  );
};

const mapStateToProps = (store) => ({
  slabImageWidth: store.sqftSlabState.slabImageWidth,
  slabImageHeight: store.sqftSlabState.slabImageHeight,
  cropperData: store.sqftSlabState.cropperData,
  pricePerArea: store.sqftSlabState.pricePerArea,
  activeStep: store.sqftSlabState.activeStep,
  slabImageType: store.sqftSlabState.slabImageType,
  isSizeValidationFailed: store.sqftSlabState.isSizeValidationFailed,
});

const mapDispatchToProps = {
  setActiveStep,
  setActiveSlabUrl,
  setSlabImageWidth,
  setSlabImageHeight,
  setSlabSearchText,
  setSlabAspectRatio,
  setPricePerArea,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftLoadSlabHeader)
);
